import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import createFAIcon from './createFAIcon';

const QueueIcon = createFAIcon(solid('list-ul'));

export default QueueIcon;
